{
  "vitalsEntry": {
    "title": "生命体征",
    "subtitle": "记录并查看生命体征",
    "printLabel": "打印生命体征",
    "recordSection": "记录生命体征",
    "save": "记录生命体征",
    "cancel": "取消",
    "saving": "正在记录...",
    "recordedSuccess": "生命体征记录成功",
    "recordedError": "记录生命体征失败",
    "invalidEncounter": "就诊编号无效。",
    "historyTitle": "近期生命体征",
    "loadingHistory": "正在加载生命体征...",
    "loadError": "加载生命体征失败。",
    "emptyHistory": "本次就诊未记录生命体征。",
    "morseTitle": "Morse 跌倒风险评估量表",
    "bradenTitle": "Braden 压疮风险评估量表",
    "riskScalesSaved": "风险评分记录成功",
    "riskScalesFailed": "生命体征已保存，但风险评分记录失败"
  },
  "vitals": {
    "systolic": "收缩压",
    "diastolic": "舒张压",
    "heartRate": "心率",
    "respiratoryRate": "呼吸频率",
    "temperature": "体温",
    "oxygenSaturation": "血氧饱和度 (SpO2)",
    "oxygenSaturationShort": "SpO2",
    "painScore": "疼痛评分",
    "weight": "体重",
    "height": "身高",
    "bmi": "BMI",
    "rangeError": "{{field}}应在 {{min}} 至 {{max}} 之间",
    "placeholders": {
      "temperature": "例如：37.0",
      "heartRate": "例如：72",
      "respiratoryRate": "例如：16",
      "oxygenSaturation": "例如：98",
      "systolic": "例如：120",
      "diastolic": "例如：80",
      "weight": "例如：70.5",
      "height": "例如：175",
      "painScore": "0-10"
    }
  },
  "vitalsRange": {
    "normal": "正常",
    "borderline": "临界",
    "abnormal": "异常",
    "critical": "危急"
  },
  "tableHeaders": {
    "dateTime": "日期/时间",
    "temperature": "体温",
    "heartRate": "心率",
    "respiratoryRate": "呼吸",
    "bloodPressure": "血压",
    "oxygenSaturation": "SpO2",
    "weight": "体重",
    "height": "身高",
    "pain": "疼痛"
  },
  "io": {
    "title": "出入量",
    "addRecord": "添加记录",
    "addRecordSection": "添加出入量记录",
    "loading": "正在加载出入量记录...",
    "loadError": "加载出入量记录失败。",
    "empty": "本次就诊未记录出入量。",
    "totals": {
      "intake": "总入量",
      "output": "总出量",
      "balance": "净平衡",
      "totalsRow": "合计",
      "netLabel": "净值"
    },
    "negativeWarning": "负平衡 — 请评估液体状态",
    "columns": {
      "dateTime": "日期/时间",
      "type": "类型",
      "category": "种类",
      "amount": "量 (ml)",
      "notes": "备注"
    },
    "fields": {
      "type": "类型",
      "category": "种类",
      "amount": "量 (ml)",
      "notes": "备注"
    },
    "type": {
      "intake": "入量",
      "output": "出量"
    },
    "categoryPlaceholder": "选择种类...",
    "amountPlaceholder": "0",
    "notesPlaceholder": "可选备注...",
    "save": "保存记录",
    "cancel": "取消",
    "missingValueShort": "--",
    "toast": {
      "added": "出入量记录已添加",
      "addFailed": "添加出入量记录失败",
      "missingFields": "请填写必填项"
    }
  },
  "intake": {
    "oral": "口服",
    "iv": "IV",
    "bloodProducts": "血制品",
    "tpn": "TPN",
    "tubeFeeding": "管饲",
    "other": "其他"
  },
  "output": {
    "urine": "尿量",
    "drain": "引流",
    "emesis": "呕吐物",
    "stool": "粪便",
    "bloodLoss": "失血",
    "ngSuction": "NG 抽吸",
    "other": "其他"
  },
  "wound": {
    "title": "伤口护理记录",
    "subtitle": "就诊 #{{id}} — 结构化伤口评估",
    "newAssessment": "新建伤口评估",
    "dimensionsTitle": "尺寸（厘米）",
    "woundBedTitle": "伤口床 (%)",
    "woundBedTotalWarning": "合计：{{total}}%（应为 100%）",
    "woundBedTotalOk": "合计：100%",
    "previousTitle": "既往评估",
    "empty": "本次就诊未记录伤口评估。",
    "invalidEncounter": "就诊编号无效。",
    "save": "保存评估",
    "savedSuccess": "已记录伤口评估",
    "savedError": "保存伤口评估失败",
    "fields": {
      "woundType": "伤口类型",
      "location": "部位",
      "stage": "分期",
      "length": "长",
      "width": "宽",
      "depth": "深",
      "granulation": "肉芽组织",
      "slough": "腐肉",
      "eschar": "焦痂",
      "epithelial": "上皮",
      "drainageType": "渗液类型",
      "drainageAmount": "渗液量",
      "surroundingSkin": "周围皮肤",
      "treatment": "处置措施",
      "painScore": "疼痛评分 (0-10)",
      "notes": "备注"
    },
    "placeholders": {
      "length": "例如：3.5",
      "width": "例如：2.0",
      "depth": "例如：0.5",
      "treatment": "描述已实施的伤口护理...",
      "notes": "其他观察..."
    },
    "history": {
      "dimensionsLabel": "尺寸",
      "drainageLabel": "渗液",
      "painLabel": "疼痛",
      "treatmentLabel": "处置"
    },
    "stage": {
      "stage1": "1 期",
      "stage2": "2 期",
      "stage3": "3 期",
      "stage4": "4 期",
      "unstageable": "无法分期",
      "deepTissue": "深部组织损伤",
      "na": "N/A"
    },
    "drainageType": {
      "none": "无",
      "serous": "浆液性",
      "sanguineous": "血性",
      "serosanguineous": "浆液血性",
      "purulent": "脓性"
    },
    "drainageAmount": {
      "none": "无",
      "scant": "极少",
      "small": "少量",
      "moderate": "中等量",
      "large": "大量",
      "copious": "极多"
    },
    "woundType": {
      "pressure": "压力性损伤",
      "surgical": "手术（伤口）",
      "diabetic": "糖尿病溃疡",
      "venous": "静脉溃疡",
      "arterial": "动脉溃疡",
      "traumatic": "创伤性",
      "skinTear": "皮肤撕裂伤",
      "other": "其他"
    },
    "location": {
      "sacrum": "骶部",
      "coccyx": "尾骨",
      "leftHeel": "左足跟",
      "rightHeel": "右足跟",
      "leftTrochanter": "左粗隆",
      "rightTrochanter": "右粗隆",
      "abdomen": "腹部",
      "leftLeg": "左腿",
      "rightLeg": "右腿",
      "back": "背部",
      "other": "其他"
    },
    "surroundingSkin": {
      "intact": "完整",
      "erythema": "红斑",
      "macerated": "浸渍",
      "indurated": "硬结",
      "edematous": "水肿",
      "warm": "发热",
      "discolored": "变色"
    }
  },
  "carePlan": {
    "title": "护理计划",
    "addPlan": "新增护理计划",
    "newPlan": "新建护理计划",
    "createPlan": "创建计划",
    "cancel": "取消",
    "empty": "本患者未记录护理计划。",
    "emptyGoals": "尚未设定目标。",
    "goals": "目标",
    "addGoal": "新增目标",
    "saving": "保存中...",
    "loading": "正在加载护理计划...",
    "loadError": "加载护理计划失败。",
    "fields": {
      "title": "标题",
      "startDate": "起始日期",
      "targetDate": "目标日期",
      "description": "描述",
      "target": "目标值"
    },
    "placeholders": {
      "title": "例如：跌倒预防计划",
      "description": "目标描述",
      "target": "例如：30 天内无跌倒"
    },
    "history": {
      "startLabel": "起始",
      "targetLabel": "目标",
      "goalsLabel": "目标数"
    },
    "status": {
      "active": "进行中",
      "completed": "已完成",
      "cancelled": "已取消"
    },
    "goalStatus": {
      "inProgress": "进行中",
      "achieved": "已达成",
      "notAchieved": "未达成"
    },
    "toast": {
      "planCreated": "护理计划已创建",
      "planCreateFailed": "创建护理计划失败",
      "goalAdded": "目标已新增",
      "goalAddFailed": "新增目标失败",
      "planValidation": "标题和起始日期为必填项",
      "goalValidation": "描述和目标值为必填项"
    }
  }
}
